export const ROLE_PATH = {
  user: "/user",
  admin: "/admin",
  superAdmin: "/superAdmin",
  manager: "/manager",
  teamleader: "/teamleader",
  executive: "/executive",
  telecaller: "/telecaller",
};

export const ROLE = {
  admin: "admin",
  user: "user",
  manager: "manager",
  teamleader: "teamleader",
  telecaller: "telecaller",
  executive: "executive",
};
